import React from 'react';
import { useEffect } from 'react';

export default function Candidatetest() {

    useEffect(() => {
        if (window.location.pathname.split('/')[1] === 'candidatetest' && window.location.pathname.split('/')[2] !== '') {
            window.location.href = `https://demo.gappeo.ai/candidatetest/${window.location.pathname.split('/')[2]}`
        }
    }, []);
    
    return (
        <div>

            <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%,-50%)' }}>
                <img src='/images/spinner.svg' alt='' />
            </div>
        </div>
    )
}
